export const TOPBRED_API_BASE_URL = 'https://api.topbred.com'
// export const TOPBRED_API_BASE_URL = 'http://localhost:8000'

export const capitalizeFirstLetter = (s) => {
    console.log("s: " + s);
    if(s){
        return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();    
    }
    return "";
}